(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner_en_vivo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var OFFSET_MIN = -360; // Ciudad de México, UTC-6 sin horario de verano
    var DAY = 86400000;
    var DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
    var MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
    var DIAS_C = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'];
    var MESES_C = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
    var RE_DATE = /^\d{4}-\d{2}-\d{2}$/;
    var RE_TIME = /^([01]?\d|2[0-3]):[0-5]\d$/;

    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }
    function cleanDate(s) { s = (s || '').trim(); return RE_DATE.test(s) ? s : ''; }
    function cleanTime(s) { s = (s || '').trim(); return RE_TIME.test(s) ? s : ''; }
    function daysInMonth(y, m) { return new Date(Date.UTC(y, m, 0)).getUTCDate(); }

    // Fecha y hora de un instante, vista desde Ciudad de México
    function mx(ms) {
      var d = new Date(ms + OFFSET_MIN * 60000);
      return { y: d.getUTCFullYear(), m: d.getUTCMonth() + 1, d: d.getUTCDate(), w: d.getUTCDay(), h: d.getUTCHours(), min: d.getUTCMinutes() };
    }
    // "2026-10-07" + "20:00" en hora de CDMX → milisegundos reales
    function mxToMs(date, time) {
      var a = date.split('-'), t = time.split(':');
      return Date.UTC(+a[0], +a[1] - 1, +a[2], +t[0], +t[1]) - OFFSET_MIN * 60000;
    }

    // Genera los lives de ayer a 62 días adelante según cada regla
    function occurrences(rules, now) {
      var out = [], b = mx(now), baseDay = Date.UTC(b.y, b.m - 1, b.d);
      rules.forEach(function (r) {
        if (!r.activo) return;
        var hora = cleanTime(r.hora);
        if (!hora) return;
        var ini = cleanDate(r.inicio), fin = cleanDate(r.fin);
        var horaFin = cleanTime(r.horaFin);
        var dur = Math.max(5, +r.duracion || 60) * 60000;
        var add = function (key) {
          var s = mxToMs(key, hora);
          var e = s + dur;
          // Si hay hora de finalización, manda sobre la duración.
          // Si es menor o igual al inicio, el live cruza la medianoche.
          if (horaFin) {
            e = mxToMs(key, horaFin);
            if (e <= s) e += DAY;
          }
          out.push({ titulo: r.titulo, link: r.link, start: s, end: e });
        };

        if (r.repeticion === 'unica') { if (ini) add(ini); return; }

        for (var i = -1; i <= 62; i++) {
          var dd = new Date(baseDay + i * DAY);
          var y = dd.getUTCFullYear(), m = dd.getUTCMonth() + 1, d = dd.getUTCDate(), w = dd.getUTCDay();
          var key = y + '-' + pad(m) + '-' + pad(d);
          if (ini && key < ini) continue;
          if (fin && key > fin) continue;
          var match = r.repeticion === 'mensual'
            ? d === Math.min(+r.diaMes, daysInMonth(y, m))
            : w === +r.diaSemana;
          if (match) add(key);
        }
      });
      return out.sort(function (a, b) { return a.start - b.start; });
    }

    function pick(list, now) {
      var live = null, next = null;
      list.forEach(function (o) {
        if (o.start <= now && now < o.end) { if (!live) live = o; }
        else if (o.start > now && !next) next = o;
      });
      return { live: live, next: next };
    }

    function hora12(p) { return (p.h % 12 || 12) + ':' + pad(p.min) + ' ' + (p.h < 12 ? 'am' : 'pm'); }

    // corto = true: "Mié 7 oct, 8:00 pm" para mobile
    function cuando(ms, now, corto) {
      var p = mx(ms), n = mx(now);
      var diff = Math.round((Date.UTC(p.y, p.m - 1, p.d) - Date.UTC(n.y, n.m - 1, n.d)) / DAY);
      var dia;
      if (diff === 0) dia = 'Hoy';
      else if (diff === 1) dia = 'Mañana';
      else if (corto) dia = DIAS_C[p.w] + ' ' + p.d + ' ' + MESES_C[p.m - 1];
      else dia = cap(DIAS[p.w]) + ' ' + p.d + ' de ' + MESES[p.m - 1];
      return dia + ', ' + hora12(p);
    }

    function setText(el, txt) { if (el && el.textContent !== txt) el.textContent = txt; }

    function init(root) {
      if (!root) return;
      if (root._gjTimer) clearInterval(root._gjTimer);

      var rules = [];
      try { rules = JSON.parse(root.querySelector('[data-gj-rules]').textContent) || []; } catch (e) { rules = []; }

      var q = function (s) { return root.querySelector(s); };
      var ui = { href: q('[data-gj-href]'), badge: q('[data-gj-badge]'), title: q('[data-gj-title]'), when: q('[data-gj-when]'), whenShort: q('[data-gj-when-short]'), btn: q('[data-gj-btn]') };
      var cfg = root.dataset;

      function tick() {
        var now = Date.now();
        var r = pick(occurrences(rules, now), now);
        var ev = r.live || r.next;

        if (!ev) {
          if (cfg.designMode === 'true') {
            root.hidden = false;
            root.classList.remove('is-live');
            setText(ui.badge, 'Sin lives programados');
            setText(ui.title, 'Agrega un evento en el editor del tema');
            setText(ui.when, ''); setText(ui.whenShort, ''); setText(ui.btn, cfg.btnNext);
          } else {
            root.hidden = true;
          }
          return;
        }

        root.hidden = false;
        ui.href.href = ev.link || cfg.fb || '#';

        if (r.live) {
          root.classList.add('is-live');
          setText(ui.badge, cfg.labelLive);
          setText(ui.title, ev.titulo);
          setText(ui.when, 'Hasta las ' + hora12(mx(ev.end)));
          setText(ui.whenShort, 'Hasta las ' + hora12(mx(ev.end)));
          setText(ui.btn, cfg.btnLive);
        } else {
          root.classList.remove('is-live');
          setText(ui.badge, cfg.labelNext);
          setText(ui.title, ev.titulo);
          setText(ui.when, cuando(ev.start, now, false));
          setText(ui.whenShort, cuando(ev.start, now, true));
          setText(ui.btn, cfg.btnNext);
        }
      }

      tick();
      root._gjTimer = setInterval(tick, 30000);
    }

    function initAll() { document.querySelectorAll('[data-gj-live]').forEach(init); }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();

    // Editor del tema: reinicia al guardar cambios en la sección
    document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-gj-live]')); });
    document.addEventListener('shopify:section:unload', function (e) {
      var el = e.target.querySelector('[data-gj-live]');
      if (el && el._gjTimer) clearInterval(el._gjTimer);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social_proof_images"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function seccion(el) { return el.closest('[data-gj-tst]'); }

    document.addEventListener('click', function (e) {
      var abrir = e.target.closest('[data-gj-tst-open]');
      if (abrir) {
        var sec = seccion(abrir);
        var dialog = sec && sec.querySelector('[data-gj-tst-dialog]');
        if (!dialog || typeof dialog.showModal !== 'function') return;
        // La imagen se crea al abrir, así el HTML no lleva un <img> vacío
        var img = document.createElement('img');
        img.className = 'gj-tst__full';
        img.src = abrir.dataset.full;
        img.alt = abrir.dataset.alt || '';
        if (abrir.dataset.w && abrir.dataset.h) {
          img.width = abrir.dataset.w;
          img.height = abrir.dataset.h;
        }
        dialog.querySelector('[data-gj-tst-frame]').replaceChildren(img);
        sec.classList.add('is-paused');
        dialog.showModal();
        return;
      }

      if (e.target.closest('[data-gj-tst-close]')) {
        e.target.closest('dialog').close();
        return;
      }

      // Clic fuera de la imagen cierra la vista ampliada
      if (e.target.matches('[data-gj-tst-dialog]')) e.target.close();
    });

    // Al cerrar (botón, clic afuera o tecla Esc) el carrusel retoma su movimiento
    document.addEventListener('close', function (e) {
      if (!e.target.matches || !e.target.matches('[data-gj-tst-dialog]')) return;
      var sec = seccion(e.target);
      if (sec) sec.classList.remove('is-paused');
      var frame = e.target.querySelector('[data-gj-tst-frame]');
      if (frame) frame.replaceChildren();
    }, true);
  })();

  } catch(e) { console.error(e); }
})();
})();
